<!--
 * @Author: Cathy
 * @Date: 2020-02-25 16:51:26
 * @LastEditors: yezi
 * @LastEditTime: 2020-07-16 15:03:35
 * @Description: 产品介绍
 -->
<template>
 <div class="productIndex">
    <topMenu :isShowMenu="false" pageType="product" />
    <isWeixinMark :isWeixin="isWeixin" @onCancelMark="isWeixin=false" />
    <!-- <img class="downloadImg" src="../assets/images/xiazai_chang.png" @click="onDownload" /> -->
    <div class="productList">
      <img v-for="(item, index) in list" :key="index" :src="item.sources" @click="onToDetail(item.content)" />
    </div>
 </div>
</template>

<script>
import topMenu from '../components/topMenu'
import isWeixinMark from '../components/isWeixinMark'
import { getList } from '../api/wap'
export default {
  name: 'productIndex',
  components: {
    topMenu,
    isWeixinMark
  },
  data () {
    return {
      list: [],
      downloadLink: '',
      isWeixin: false
    }
  },
  created () {
    this.onLoadData()
  },
  methods: {
    onLoadData () {
      getList({ type: 3 })
        .then(res => {
          this.list = res.result.list
          this.downloadLink = res.result.download_url.android
        })
    },
    onToDetail (content) {
      this.$router.push({
        path: '/productDetail',
        query: {
          content: content,
          downloadLink: this.downloadLink
        }
      })
    },
    onDownload () {
      const u = window.navigator.userAgent
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // android终端或者uc浏览器
      const isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isIos) {
        location.href = 'https://apps.apple.com/cn/app/%E8%81%94%E5%90%A7/id1404140841'
      }
      if (isAndroid) {
        this.isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1
        if (!this.isWeixin) {
          location.href = this.downloadLink
        }
      }
    }
  }
}
</script>

<style scoped>
.downloadImg {
  margin-top: 0.54rem;
  width:7.11rem;
  height:1.4rem;
  margin-left: 0.2rem;
}
.productList{
  margin: 0 0.2rem;
}
.productList img {
  margin-top: 0.3rem;
  width: 100%;
  border-radius: 0.16rem;
}

.isWeixin {
  width: 100%;
  height: 100vh;
  background-color: rgba(13, 13, 13, 0.6);
  position: fixed;
  top: 0;
  left: 0;
}
.toastText {
  color: rgba(255, 255, 255, 0.7);
  margin: 0.1rem 0.4rem 0 0;
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
}
.toastText img {
  width: 1.25rem;
  height: 1.25rem;
  margin-left: 0.1rem;
  opacity: 0.7;
}
</style>
